import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var RefreshCcw04 = function RefreshCcw04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M17 18.8746c2.1213-1.5456 3.5-4.0491 3.5-6.8746 0-4.6944-3.8056-8.5-8.5-8.5h-.5m.5 17c-4.6944 0-8.5-3.8056-8.5-8.5 0-2.8256 1.3787-5.329 3.5-6.8746M11 22.4l2-2-2-2m2-12.8-2-2 2-2"
    })
  }));
};
export default RefreshCcw04;